import { z } from 'zod';
import { BulkEditSelectionSchema } from './media-units-bulk-edit.js';
import { endpoint } from '../api/endpoint.js';

/**
 * "Recompute location from coordinates" bulk action — re-derives county
 * (powiat), region (województwo), and agglomeration for a bulk selection's
 * locations from their stored lat/lng, using the same offline PostGIS
 * resolver + agglomeration lookup as the bulk-import enrichment path.
 *
 * Reuses `BulkEditSelectionSchema` verbatim (the same `{ ids } | { filter }`
 * union and 500-row `BULK_EDIT_CAP` as `bulk-edit`).
 *
 * Traceability: bulk-edit-media / Requirement: Bulk "recompute location from
 * coordinates" action.
 */
export const bulkRecomputeLocationRequestSchema = z.object({
  selection: BulkEditSelectionSchema,
});
export type BulkRecomputeLocationRequest = z.infer<typeof bulkRecomputeLocationRequestSchema>;

// Mirrors bulkEditResponseSchema's shape verbatim.
export const bulkRecomputeLocationResponseSchema = z.object({
  updated: z.number().int().min(0),
  failed: z.number().int().min(0),
  failedIds: z.array(z.number().int().positive()).optional(),
});
export type BulkRecomputeLocationResponse = z.infer<typeof bulkRecomputeLocationResponseSchema>;

export const bulkRecomputeLocationEndpoint = endpoint(
  'POST',
  '/media-units/bulk-recompute-location',
  bulkRecomputeLocationRequestSchema,
  bulkRecomputeLocationResponseSchema,
);
